exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card:hover .icon-size[data-v-60e3e1f0]{opacity:.6;transition:.5s}", ""]);

// exports
